import Http from './Http'

class LinkService extends Http {
  constructor () {
    super('/links')
  }

  async isAvailable ({ shortened, domain_id }) {
    const data = await this.show(`/available?shortened=${shortened}&domain_id=${domain_id || ''}`)
    return data.available
  }
}

export default new LinkService()
